import { camelCase, snakeCase } from 'change-case';

export function plainApiToModel<T>(item: any): T;
export function plainApiToModel<T>(item: any[]): T[];
export function plainApiToModel<T>(items: any | any[]): T | T[] | {}[] {
  const result = (Array.isArray(items) ? items : [items]).map((item) => {
    return item
      ? (Object.fromEntries(
          Object.entries(item).map(([key, value]) => [camelCase(key), value]),
        ) as unknown as T)
      : [];
  });
  return Array.isArray(items) ? result : result[0];
}

export function modelToPlainApi<T>(item: T): any;
export function modelToPlainApi<T>(item: T[]): any[];
export function modelToPlainApi<T>(items: T | T[]): any | any[] {
  const result = (Array.isArray(items) ? items : [items]).map(
    (item) =>
      Object.fromEntries(
        Object.entries(item).map(([key, value]) => [snakeCase(key), value]),
      ) as unknown as T,
  );
  return Array.isArray(items) ? result : result[0];
}
